import { Structure } from "./structure";
import { Property } from "./property";
import { computedFrom } from 'aurelia-framework';


export class Zone {
	id: string;
	code: string;
	name: string;
	gpsCoordinates: any;
	displayMap: boolean;
	isWeatherZone: boolean;
	locationId: string;
	structures: Array<Structure>;
	deviceTypeIds: Array<string>;
	properties: Array<Property>;
	hasCurtainControllers: boolean;

	@computedFrom('structures')
	get sortedStructures(): Array<Structure> {
		return [... this.structures]
			.sort((a, b) => a.name.localeCompare(b.name, undefined, { numeric: true }));
	}

}